module.exports = __webpack_public_path__ + "static/media/greenhouse2Step12-3.cc59ff7f.jpg";